import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { CloseIcon, MenuIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
/**
 * ヘッダー：ゲスト用メニュー開閉ボタン（SP表示用）
 * @param props
 * @returns
 */
export const HeaderGuestMenuToggleButton = (props) => {
    const { className = '', isOpen, onClickMenu } = props;
    return (_jsx("button", Object.assign({ className: clsx('inline-flex', className), onClick: onClickMenu, type: 'button' }, { children: isOpen ? (_jsx(CloseIcon, { color: 'primary', size: 'md' })) : (_jsx(MenuIcon, { color: 'primary', size: 'md' })) })));
};
